<div id="content">
  <div class="page-title">
    <h1>Canales de comunicación</h1>
    <button mat-flat-button color="accent" type="button" (click)="sync()" [disabled]="syncing">
      <mat-icon>sync</mat-icon>
      {{ syncing ? 'Sincronizando…' : 'Sincronizar catálogo' }}
    </button>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field appearance="outline">
        <mat-label>Buscar</mat-label>
        <input matInput formControlName="search" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Asignación</mat-label>
        <mat-select formControlName="assignment_filter" (selectionChange)="pageIndex = 0; fetchData()">
          <mat-option value="pending">Pendientes de asignar</mat-option>
          <mat-option value="ignored">Ignoradas para asignación</mat-option>
          <mat-option value="all">Todas</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="space_type" (selectionChange)="pageIndex = 0; fetchData()">
          <mat-option value="">Todos</mat-option>
          <mat-option value="DIRECT_MESSAGE">Personal</mat-option>
          <mat-option value="SPACE,GROUP_CHAT">Grupo</mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="display_name">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let row">
            <div>{{ row.display_name }}</div>
            <small>{{ row.external_id }}</small>
          </td>
        </ng-container>

        <ng-container matColumnDef="provider">
          <th mat-header-cell *matHeaderCellDef>Proveedor</th>
          <td mat-cell *matCellDef="let row">{{ row.provider_label }}</td>
        </ng-container>

        <ng-container matColumnDef="space_type">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let row">
            <span [class]="'space-type-chip ' + row.space_type_chip_class">{{ row.space_type_label }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="assignment">
          <th mat-header-cell *matHeaderCellDef>Asignación</th>
          <td mat-cell *matCellDef="let row">
            @if (row.is_pending_assignment) {
              <button mat-stroked-button type="button" color="primary" (click)="openAssignDialog(row)">Asignar…</button>
            } @else {
              {{ row.assignment_label }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button [matMenuTriggerFor]="menu" type="button">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              @if (row.is_pending_assignment) {
                <button mat-menu-item type="button" (click)="openAssignDialog(row)">Asignar…</button>
              }
              @if (row.can_ignore_for_assignment) {
                <button mat-menu-item type="button" (click)="ignoreForAssignment(row)">Ignorar para asignación</button>
              }
              @if (row.can_unignore_for_assignment) {
                <button mat-menu-item type="button" (click)="unignoreForAssignment(row)">Volver a pendientes</button>
              }
              @if (!row.is_unassigned) {
                <button mat-menu-item type="button" (click)="unassign(row)">Desasignar</button>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
